<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-4 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-8 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteSelectedResellers(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="$router.push('/resellers/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Reseller</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div></div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-3 col-lg-4 col-md-5 col-sm-5 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-1"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 col-sm-6 ml-auto d-inline-block"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button
                    slot="title"
                    type="none"
                    class="pl-0 pr-0 icon-only"
                  >
                    <i class="flaticon-downloading-files mr-0 "></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="resellersResponse.pages"
            :total="resellersResponse.count"
            v-model="currentPage"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="resellers"
            :fields="fields"
            sort-by.sync="created_at"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length === resellers.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #thead-top=""> </template>

            <template #cell(first_name)="data">
              <div class="d-flex align-items-center link-img-profile">
                <div
                  v-if="data.item.url_picture"
                  class="img-user-list mr-2"
                  v-bind:style="{
                    backgroundImage: `url('${data.item.url_picture}')`
                  }"
                ></div>

                <div
                  v-else
                  class="img-user-list mr-2"
                  v-bind:style="{
                    backgroundImage: 'url(' + imageProfile + ')'
                  }"
                ></div>
                <div class="d-inline-flex">
                  <div v-if="'travel_agency' === data.item.type">
                    <span class="role-table capitalize">
                      {{ data.item.first_name }} {{ data.item.last_name }}
                    </span>
                    <router-link
                      class="capitalize hide-data"
                      :to="`/resellers/${data.item._id}`"
                      >{{ data.item.company_name }}</router-link
                    >
                  </div>
                  <div v-else>
                    <span
                      class="role-table capitalize"
                      v-if="data.item.association"
                    >
                      {{ data.item.association.company_name }}
                    </span>
                    <router-link
                      class="capitalize hide-data"
                      :to="`/resellers/${data.item._id}`"
                      >{{ data.item.first_name }}
                      {{ data.item.last_name }}</router-link
                    >
                  </div>
                </div>

                <div class="d-inline-flex">
                  <el-tooltip
                    content="Confirmed"
                    placement="bottom"
                    v-if="data.item.status"
                  >
                    <i
                      class="flaticon-check-2 text-success mt-1  ml-1 f-14"
                    ></i>
                  </el-tooltip>

                  <el-tooltip v-else content="No Confirmed" placement="bottom">
                    <i class="flaticon-check-2 text-danger mt-1 ml-1 f-14"></i>
                  </el-tooltip>
                </div>
              </div>
            </template>

            <template #cell(gender)="data">
              <span class="capitalize">{{
                formatGenderLabel(data.item.gender)
              }}</span>
            </template>

            <template #cell(country)="data">
              <span class="capitalize" v-if="data.item.country">{{
                data.item.country
              }}</span>
              <span v-else>--</span>
            </template>

            <template #cell(phone)="data">
              <span class="hide-data capitalize">{{ data.item.phone }}</span>
            </template>

            <template #cell(email)="data">
              <a
                class="hide-data"
                :href="
                  `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.email}`
                "
                target="_blank"
                >{{ data.item.email }}</a
              >
            </template>

            <template #cell(markup)="data">
              <span>{{ data.item.mark_up }}%</span>
            </template>
            <template #cell(commercialTerms)="data">
              <span class="f-12 d-block">{{
                formatCommercialTerms(data.item.type_charge)
              }}</span>
              <span v-if="data.item.type_charge === 'commission'"
                >{{ data.item.commission }}%</span
              >
            </template>

            <template #cell(actions)="data">
              <el-tooltip
                content="History"
                placement="bottom"
                class="d-inline-flex"
              >
                <span
                  class="icon-action text-blue mr-2"
                  @click.stop="openResellerHistoryModal(data.item._id)"
                >
                  <i class="flaticon-wall-clock-1"> </i>
                </span>
              </el-tooltip>

              <ActionLink
                :basePath="'/resellers'"
                :id="data.item._id"
                :canUpdate="canUserUpdate"
                :canRead="canUserRead"
                :linkClass="'icon-action'"
                :iconExtraClass="'text-primary'"
              />

              <el-tooltip content="Delete" placement="bottom">
                <span
                  v-if="canUserDelete"
                  class="icon-action text-danger ml-2"
                  @click="deleteReseller(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>
          <pagination-block
            :pageCount="resellersResponse.pages"
            :total="resellersResponse.count"
            :limit="limit"
            @changeLimit="changeLimit"
            v-model="currentPage"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>

    <ResellerHistory
      :show="showResellerHistory"
      :tempResellerId="tempResellerId"
      @close="closeResellerHistoryModal"
    />
  </section>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { ResellersAPI, DocumentsAPI } from "../../../core/api";
import Swal from "sweetalert2";
import ResellerHistory from "../components/ResellerHistory";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
import ActionLink from "../../../components/ActionLink.vue";
import {
  formatCommercialTerms,
  formatGenderLabel,
  formatExportFilename
} from "../services/format.service";
import { select } from "d3";
export default {
  name: "Resellers",
  components: {
    ResellerHistory,
    ActionLink
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center ",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "first_name",
          label: "Resellers",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
          thStyle: { minWidth: "80px" },
          class: "alinmov6"
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },
        {
          key: "phone",
          label: "Contact N°",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "markup",
          label: "Markup",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "commercialTerms",
          label: "Terms",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "position-relative alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "full_name",
          text: "Reseller FullName"
        },
        {
          value: "company_name",
          text: "Business Name"
        },
        { value: "created_at", text: "Created At" }
      ],
      timeoutId: null,
      filterStatus: "all",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      view: "table",
      guides: [],
      loader: false,
      visibleSideBar: false,
      tempResellerId: null,
      showResellerHistory: false
    };
  },
  watch: {},
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Resellers",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    await this.getLimit();
    this.limit = this.resellerSearchCriteria.limit || this.paginationLimit;
    this.currentPage = this.resellerSearchCriteria.currentPage;
    this.query = this.resellerSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    getValue(value) {
      return typeof value === "string" ? value.trim() : value;
    },
    addElementInQuery(query, key, value) {
      let parseValue = this.getValue(value);
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, parseValue);
      } else {
        searchParams.append(key, parseValue);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteReseller(resellerId) {
      let { value } = await Swal.fire({
        title: "Delete Reseller",
        text: "Are you sure do you want to delete this Reseller?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteResellerById(resellerId);
      }
    },
    async deleteResellerById(resellerId) {
      try {
        this.setLoad(true);
        let { data } = await ResellersAPI.deleteResellerById(
          resellerId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "Reseller cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteSelectedResellers(resellers = []) {
      let { value } = await Swal.fire({
        title: "Delete Resellers",
        text: "Are you sure do you want to delete the selected Resellers?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        const ids = resellers.map(reseller => reseller._id);
        await this.bulkDeleteResellers(ids);
      }
    },
    async bulkDeleteResellers(ids = []) {
      try {
        this.setLoad(true);
        let { data } = await ResellersAPI.bulkDeleteResellers(
          { ids: ids },
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              ids.length > 1
                ? "Resellers cannot be deleted since they are currently assigned to one or many reservations."
                : "Reseller cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(resellers = []) {
      try {
        this.setLoad(true);
        const ids = resellers.map(reseller => reseller._id);
        let { data } = await ResellersAPI.exportResellers(
          { ids: ids },
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", formatExportFilename("resellers"));
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    get(loader, limit, page, query) {
      this.setResellerSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getResellers({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    initializeFilterData(query) {
      const searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
    },
    isInResellerModule(modules = []) {
      if (!modules.includes("RESELLERS")) {
        this.setResellerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    changeViewCard() {
      this.cardview = this.view === "table" ? false : true;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "RESELLERS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        return data.data ? data.data : [];
      } catch (error) {
        return [];
      }
    },
    openResellerHistoryModal(rateId) {
      this.tempResellerId = rateId;
      this.showResellerHistory = !this.showResellerHistory;
    },
    closeResellerHistoryModal() {
      this.showResellerHistory = false;
      this.tempResellerId = null;
    },
    formatCommercialTerms,
    formatGenderLabel,
    ...mapActions(["getResellers", "getLimit"]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setResellerSearchCriteria"
    ])
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  computed: {
    resellers: function() {
      return this.resellersResponse.docs ? this.resellersResponse.docs : [];
    },
    ...mapGetters([
      "resellersResponse",
      "sesion",
      "userRole",
      "paginationLimit",
      "resellerSearchCriteria"
    ]),
    canUserDelete() {
      return isUserAuthorized("RESELLERS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("RESELLERS", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("RESELLERS", this.userRole, "UPDATE");
    },
    canUserRead() {
      return isUserAuthorized("RESELLERS", this.userRole, "READ");
    },
    canUserExport() {
      return isUserAuthorized("RESELLERS", this.userRole, "EXPORT");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInResellerModule(to.meta.modules);
    next();
  }
};
</script>
